import { Pipe, PipeTransform } from '@angular/core';

@Pipe( { name: 'duration' } )
export class DurationPipe implements PipeTransform {
    transform(startTime: any, finishedTime: any): any {
        const durationInSeconds = (new Date(finishedTime).getTime() - new Date(startTime).getTime()) / 1000;
        const hours = Math.floor(durationInSeconds / 3600);
        const minutes = Math.floor((durationInSeconds % 3600) / 60);
        return (hours > 0 ? (hours + ' Hr ') : '') + (minutes > 0 ? (minutes + ' Min ') : '');
    }
}
